import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetAllSchools = async (uid) => {
  try {
    const SchoolsCollection = await collection(db, "Schools");

    const q = query(
      SchoolsCollection,
      where("uid", "==", uid),
      where("IsDeleted", "==", false)
    );
    const SchoolsSnapshot = await getDocs(q);

    let SchoolsData = [];

    SchoolsSnapshot.forEach((doc) => {
      SchoolsData.push({ ...doc.data(), id: doc.id });
    });
    return SchoolsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllSchools;
